import { IDelegateOption } from '../../config/interfaces';

/**
 * Store sub context for employee data
 */
const EmployeeContext = {
  depts: [] as string[],
  selectedDepts: [] as string[],
  // this filter is specifically used for CSC currently, but adding general name for possible future use
  isShiftStatusDataAvailable: false,
  shiftStatusFilter: '',
  selectedDelegatedEmployee: {} as IDelegateOption
};

export default EmployeeContext;
